/**
 * SHARED LEGACY FILE
 *
 * These navigation components are used by multiple apps
 * split from LearningCenterUI. They do not belong to any single app — each app
 * that needs them imports this shared copy.
 *
 * The .legacy suffix exists to preserve git history transfer.
 */
import { ACPage } from 'academy-navigation-lib/components/ACPage/ACPage';
import { useIsPartner } from '../../partners/partnersQueries';
import { FullScreen } from 'foundations-components/transitional/components/FullScreen';
import { useNavPageHandlers } from '../navigationHooks.legacy';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const NavPage = ({
  children,
  shouldRenderSearch = true,
  shouldRenderTabs = true,
  shouldRenderCompactSearchBar,
  shouldRenderFullScreen,
  shouldRenderCenteredContent = true
}) => {
  const isPartner = useIsPartner();
  const {
    isMobile
  } = useMediaQuery();
  const navPageHandlers = useNavPageHandlers();
  if (shouldRenderFullScreen) {
    return /*#__PURE__*/_jsx(FullScreen, {
      children: /*#__PURE__*/_jsx(_Fragment, {
        children: children
      })
    });
  }
  return /*#__PURE__*/_jsx(ACPage, Object.assign({
    compactNav: !isMobile,
    compactSearchBar: shouldRenderCompactSearchBar,
    fullScreen: !shouldRenderCenteredContent,
    isPartner: !!isPartner,
    renderSearch: shouldRenderSearch,
    renderTabs: shouldRenderTabs
  }, navPageHandlers, {
    children: children
  }));
};